import { Collapse, Group, Paper, Stack } from '@mantine/core';
import styles from './CollapsibleCard.module.css';
import CollapseButton from './CollapseButton';
import DeleteButton from './DeleteButton';

export const CollapsibleCard = ({
  title,
  accessibilityLabel,
  icon,
  canDelete,
  onDelete,
  childrenWhenCollapsed,
  childrenWhenExpanded,
  isCollapsed,
  onToggleCollapse,
  leftHeaderSection,
}: {
  title: React.ReactNode;
  accessibilityLabel: string;
  icon: React.ReactNode;
  canDelete: boolean;
  onDelete: () => void;
  childrenWhenCollapsed?: React.ReactNode;
  childrenWhenExpanded: React.ReactNode;
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  leftHeaderSection?: React.ReactNode;
}) => {
  const transitionDuration = 200;
  return (
    <Paper
      radius='xl'
      withBorder
      className={`${styles.collapsibleContactCard} ${
        isCollapsed ? styles.collapsed : ''
      }`}
      onClick={() => isCollapsed && onToggleCollapse()}
    >
      <Stack gap='0'>
        <Header
          title={title}
          accessibilityLabel={accessibilityLabel}
          canDelete={canDelete}
          onDelete={onDelete}
          isCollapsed={isCollapsed}
          onToggleCollapse={onToggleCollapse}
          icon={icon}
          childrenWhenCollapsed={childrenWhenCollapsed}
          leftSection={leftHeaderSection}
        />

        <Collapse in={!isCollapsed} transitionDuration={transitionDuration}>
          {childrenWhenExpanded}
        </Collapse>
      </Stack>
    </Paper>
  );
};

const Header = ({
  title,
  accessibilityLabel,
  canDelete,
  onDelete,
  isCollapsed,
  onToggleCollapse,
  icon,
  childrenWhenCollapsed,
  leftSection,
}: {
  title: React.ReactNode;
  accessibilityLabel: string;
  canDelete: boolean;
  onDelete: () => void;

  isCollapsed: boolean;
  onToggleCollapse: () => void;
  icon: React.ReactNode;
  childrenWhenCollapsed?: React.ReactNode;
  leftSection?: React.ReactNode;
}) => {
  return (
    <Group
      justify='stretch'
      align='flex-start'
      className={`${styles.header} ${!isCollapsed ? styles.expanded : ''}`}
    >
      <CollapseButton
        isCollapsed={isCollapsed}
        onToggleCollapse={onToggleCollapse}
      />
      <Stack gap='0' flex='1 0 0'>
        <Group justify='space-between' align='center'>
          <Group gap='xs'>
            {icon}
            {title}
            {leftSection}
          </Group>

          {canDelete && (
            <DeleteButton
              label={`Delete ${accessibilityLabel}`}
              onDelete={onDelete}
            />
          )}
        </Group>
        {childrenWhenCollapsed && (
          <Collapse in={isCollapsed} transitionDuration={200}>
            {childrenWhenCollapsed}
          </Collapse>
        )}
      </Stack>
    </Group>
  );
};
